const eraList = [
  { name: "明治", startDate: "1868-10-23" },
  { name: "大正", startDate: "1912-07-30" },
  { name: "昭和", startDate: "1926-12-25" },
  { name: "平成", startDate: "1989-01-08" },
  { name: "令和", startDate: "2019-05-01" }
];

export default {
  getEraList() {
    return eraList.sort((a, b) => new Date(b.startDate) - new Date(a.startDate));
  },
  /**
   * format
   */
  dateFormat(fmt) {
    let o = {
      "M+": this.getMonth() + 1,
      "d+": this.getDate(),
      "h+": this.getHours(),
      "m+": this.getMinutes(),
      "s+": this.getSeconds(),
      "q+": Math.floor((this.getMonth() + 3) / 3),
      S: this.getMilliseconds()
    };
    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
    }
    for (let k in o) {
      if (new RegExp("(" + k + ")").test(fmt)) {
        fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
      }
    }
    return fmt;
  },
  /**
   * ステップ別月の設定
   * let lastMonthDate = new Date().setMonthByStep(-1);
   */
  setMonthByStep(step) {
    return new Date(this.getFullYear(), this.getMonth() + step);
  },
  /**
   * ステップ別日の設定
   * let lastMonthDate = new Date().setDateByStep(-1);
   */
  setDateByStep(step) {
    return new Date(this.getFullYear(), this.getMonth(), this.getDate() + step);
  },
  /**
   * 月の1日
   * new Date().getFirstDayOfMonth().format("yyyy-MM-dd")
   * @returns {Date}
   */
  getFirstDayOfMonth() {
    return new Date(this.getFullYear(), this.getMonth());
  },
  /**
   * 月の末日
   * new Date().getLastDayOfMonth().format("yyyy-MM-dd")
   * @returns {Date}
   */
  getLastDayOfMonth() {
    return new Date(this.getFullYear(), this.getMonth() + 1, 0);
  },
  /**
   * 土曜日
   * @param offset
   * @returns {*}
   */
  getSaturday(offset) {
    let currentDate = new Date();
    let targetDate = new Date(currentDate);
    let currentDay = currentDate.getDay();
    let daysUntilSaturday = currentDay === 6 ? 0 : 6 - currentDay;
    targetDate.setDate(currentDate.getDate() + daysUntilSaturday + offset * 7);
    return targetDate;
  },
  /**
   * 日曜日
   * @param offset
   * @returns {*}
   */
  getSunday(offset) {
    let currentDate = new Date();
    let currentDay = currentDate.getDay();
    let daysUntilSunday = currentDay === 0 ? 0 : 0 - currentDay;
    let targetDate = new Date(currentDate);
    targetDate.setDate(currentDate.getDate() + daysUntilSunday + offset * 7);
    return targetDate;
  },
  /**
   * 開始日＞終了日の場合
   * return エラー:true
   */
  checkDateFromTo(dateFromStr, dateToStr, timeFlag) {
    if (!dateFromStr || !dateToStr) {
      return false;
    }
    if (timeFlag) {
      dateFromStr = "1970-01-01 " + dateFromStr;
      dateToStr = "1970-01-01 " + dateToStr;
    }
    let dateFrom = new Date(dateFromStr).getTime();
    let dateTo = new Date(dateToStr).getTime();
    return dateFrom > dateTo;
  },
  /**
   * 集計開始月(i1)と集計終了月(i2)の期間が1年を超えている場合、エラー
   * @param dateFromStr
   * @param dateToStr
   * @param intervalMonth
   */
  checkMonthInterval(dateFromStr, dateToStr, intervalMonth) {
    if (!dateFromStr || !dateToStr) {
      return false;
    }
    const [year1, month1] = dateFromStr.split("-");
    const [year2, month2] = dateToStr.split("-");
    const diffMonths = (year2 - year1) * 12 + (month2 - month1);
    return diffMonths >= intervalMonth;
  },

  dateFormatToFullWeek(date, type) {
    if (!date) {
      return "";
    }
    let datetime = new Date(date);
    let year = datetime.getFullYear();
    let month = datetime.getMonth() + 1;
    let strDate = datetime.getDate();
    let Hours = datetime.getHours();
    let minute = datetime.getMinutes();
    let day = "日月火水木金土".charAt(datetime.getDay());
    if (!type) {
      return (
        year +
        "/" +
        this.getNum(month) +
        "/" +
        this.getNum(strDate) +
        "（" +
        day +
        "）" +
        this.getNum(Hours) +
        ":" +
        this.getNum(minute)
      );
    } else if (type === "date") {
      return year + "/" + this.getNum(month) + "/" + this.getNum(strDate);
    } else {
      return (
        year +
        "/" +
        this.getNum(month) +
        "/" +
        this.getNum(strDate) +
        " " +
        this.getNum(Hours) +
        ":" +
        this.getNum(minute)
      );
    }
  },
  getNum(i) {
    return i < 10 ? "0" + i : i;
  },
  theSameMonth(date) {
    if (!date) {
      return;
    }
    let datetime = new Date(date);
    let year = datetime.getFullYear();
    let month = datetime.getMonth() + 1;
    return year + "" + this.getNum(month);
  }
};
